import { render, staticRenderFns } from "./notification_panel.vue?vue&type=template&id=6b7d2c19&scoped=true&"
import script from "./notification_panel.vue?vue&type=script&lang=js&"
export * from "./notification_panel.vue?vue&type=script&lang=js&"
import style0 from "./notification_panel.vue?vue&type=style&index=0&id=6b7d2c19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d2c19",
  null
  
)

export default component.exports